module.exports = __webpack_public_path__ + "img/depmap_svg_V129.f6bfc787.svg";